/*
 * @Author: lc 2631402207@qq.com
 * @Date: 2025-07-07 16:28:07
 * @LastEditors: lc 2631402207@qq.com
 * @LastEditTime: 2025-11-12 14:46:33
 * @FilePath: \senlan-ai-ui\src\pages\components\ResponseBubble\components\CopyButton\index.tsx
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { CopyOutlined, ReloadOutlined } from '@ant-design/icons'
import { Button, Space, theme, message, Avatar } from 'antd'

import { useAtom } from 'jotai'
import {
  openOnlineAtom,
  updateOnlineDataAtom,
} from '../../../../../stores/online.store'
interface Props {
  value: string
  onReload?: () => void
  onlineSearchResults?: any[]
}
const MessageFooter = (props: Props) => {
  const { token } = theme.useToken()
  const [, openOnline] = useAtom(openOnlineAtom)
  const [, updateData] = useAtom(updateOnlineDataAtom)

  return (
    <Space size={token.paddingXXS}>
      {props.value && (
        <Button
          color="default"
          variant="text"
          size="small"
          onClick={() => {
            try {
              navigator.clipboard.writeText(props?.value)
              message.success('复制成功')
            } catch (err) {
              message.error('复制失败，当前环境不支持')
            }
          }}
          icon={<CopyOutlined />}
        />
      )}
      {props.onReload && (
        <Button
          color="default"
          variant="text"
          size="small"
          onClick={props.onReload}
          icon={<ReloadOutlined />}
        />
      )}
      {Array.isArray(props.onlineSearchResults) &&
        props.onlineSearchResults.length > 0 && (
          <Button
            style={{
              height: 32,
              width: 140,
            }}
            onClick={() => {
              updateData(props.onlineSearchResults)
              openOnline()
            }}
          >
            <Avatar.Group
              max={{ count: 4 }}
              size="small"
              style={{ marginRight: 6 }}
            >
              {props.onlineSearchResults?.slice(0, 4).map((item) => (
                <Avatar src={item.icon} key={item.index} />
              ))}
            </Avatar.Group>
            <span style={{ fontSize: 14 }}>来源</span>
          </Button>
        )}
    </Space>
  )
}

export default MessageFooter
